import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { store } from './store';
import { App } from './App';
import './global.css';
// Global error handler — prevent silent failures in production
window.addEventListener('unhandledrejection', (e) => {
    console.error('[Mute] Unhandled promise rejection:', e.reason);
});
const root = createRoot(document.getElementById('root'));
root.render(_jsx(Provider, { store: store, children: _jsx(BrowserRouter, { children: _jsx(App, {}) }) }));
